import { convertUser, UsersResponse as Response, User } from '@nextforce/api'
import { useQuery, UseQueryResult } from '@tanstack/react-query'
import { useServer } from 'app/server/context'
import keys from './shared/keys'

export function useUserAccount(): UseQueryResult<User, Error> {
  const { server } = useServer()

  return useQuery({
    queryKey: keys.account(),
    queryFn: async () => {
      const response = await server.get<Response.Profile>('/v2/users/me/profile')
      return convertUser(response.user)
    },
  })
}
